import React from 'react';

const GreenTick = (props) => (
  <svg {...props} width="32" height="32" viewBox="0 0 32 32" fill="none">
    <circle fill="#FFFFFF" cx="16" cy="16" r="10" stroke="none" strokeWidth="0"></circle>
    <path color="#FFFFFF" d="M15.9997 2.66669C23.3634 2.66669 29.3335 8.63605 29.3337 15.9997C29.3337 23.3635 23.3635 29.3337 15.9997 29.3337C8.63605 29.3335 2.66669 23.3634 2.66669 15.9997C2.66686 8.63616 8.63616 2.66686 15.9997 2.66669ZM21.9929 11.7018C21.6284 11.3376 21.0379 11.3375 20.6735 11.7018L13.9997 18.3747L11.3268 15.7018C10.9624 15.3374 10.371 15.3374 10.0065 15.7018C9.64216 16.0663 9.64208 16.6577 10.0065 17.0222L13.3405 20.3552L13.4108 20.4186C13.7774 20.7179 14.318 20.6968 14.6599 20.3552L21.9929 13.0222C22.3573 12.6577 22.3573 12.0663 21.9929 11.7018Z" fill="#008744"/>
  </svg>
)

export default GreenTick